import { render, staticRenderFns } from "./CurrentExtensions.vue?vue&type=template&id=a8890952&"
import script from "./CurrentExtensions.vue?vue&type=script&lang=js&"
export * from "./CurrentExtensions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports